"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Teaser = exports.TEASER_TYPE = exports.TEASER_STYLE_TYPE = exports.TEASER_LOGO_POSITION_TYPE = exports.TEASER_IMAGE_POSITION_TYPE = exports.TEASER_CONTENT_POSITION_TYPE = exports.STYLES_WITH_BACKGROUND_BANNER = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _BannerBackground = require("./BannerBackground");
require("./Teaser.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var TEASER_TYPE = /*#__PURE__*/function (TEASER_TYPE) {
  TEASER_TYPE["banner"] = "banner";
  TEASER_TYPE["size100"] = "size100";
  TEASER_TYPE["size66"] = "size66";
  TEASER_TYPE["size50"] = "size50";
  TEASER_TYPE["size33"] = "size33";
  return TEASER_TYPE;
}({});
exports.TEASER_TYPE = TEASER_TYPE;
var TEASER_STYLE_TYPE = /*#__PURE__*/function (TEASER_STYLE_TYPE) {
  TEASER_STYLE_TYPE["light"] = "light";
  TEASER_STYLE_TYPE["dark"] = "dark";
  TEASER_STYLE_TYPE["DMKGreen"] = "DMK-Green";
  TEASER_STYLE_TYPE["DMKBlue"] = "DMK-Blue";
  TEASER_STYLE_TYPE["DMKGreyBlue"] = "DMK-GreyBlue";
  TEASER_STYLE_TYPE["DMKWarmGrey"] = "DMK-WarmGrey";
  TEASER_STYLE_TYPE["DMKYellow"] = "DMK-Yellow";
  TEASER_STYLE_TYPE["DMKRose"] = "DMK-Rose";
  TEASER_STYLE_TYPE["DMKRed"] = "DMK-Red";
  TEASER_STYLE_TYPE["DMKViolet"] = "DMK-Violet";
  TEASER_STYLE_TYPE["DMKPetrol"] = "DMK-Petrol";
  return TEASER_STYLE_TYPE;
}({});
exports.TEASER_STYLE_TYPE = TEASER_STYLE_TYPE;
var TEASER_CONTENT_POSITION_TYPE = /*#__PURE__*/function (TEASER_CONTENT_POSITION_TYPE) {
  TEASER_CONTENT_POSITION_TYPE["left"] = "left";
  TEASER_CONTENT_POSITION_TYPE["right"] = "right";
  return TEASER_CONTENT_POSITION_TYPE;
}({});
exports.TEASER_CONTENT_POSITION_TYPE = TEASER_CONTENT_POSITION_TYPE;
var TEASER_LOGO_POSITION_TYPE = /*#__PURE__*/function (TEASER_LOGO_POSITION_TYPE) {
  TEASER_LOGO_POSITION_TYPE["bottom"] = "bottom";
  TEASER_LOGO_POSITION_TYPE["top"] = "top";
  return TEASER_LOGO_POSITION_TYPE;
}({});
exports.TEASER_LOGO_POSITION_TYPE = TEASER_LOGO_POSITION_TYPE;
var TEASER_IMAGE_POSITION_TYPE = /*#__PURE__*/function (TEASER_IMAGE_POSITION_TYPE) {
  TEASER_IMAGE_POSITION_TYPE["center"] = "center";
  TEASER_IMAGE_POSITION_TYPE["left"] = "left";
  TEASER_IMAGE_POSITION_TYPE["right"] = "right";
  return TEASER_IMAGE_POSITION_TYPE;
}({});
exports.TEASER_IMAGE_POSITION_TYPE = TEASER_IMAGE_POSITION_TYPE;
var STYLES_WITH_BACKGROUND_BANNER = [TEASER_STYLE_TYPE.DMKGreen, TEASER_STYLE_TYPE.DMKBlue, TEASER_STYLE_TYPE.DMKGreyBlue, TEASER_STYLE_TYPE.DMKWarmGrey, TEASER_STYLE_TYPE.DMKYellow, TEASER_STYLE_TYPE.DMKRose, TEASER_STYLE_TYPE.DMKRed, TEASER_STYLE_TYPE.DMKViolet, TEASER_STYLE_TYPE.DMKPetrol];
exports.STYLES_WITH_BACKGROUND_BANNER = STYLES_WITH_BACKGROUND_BANNER;
var Teaser = function Teaser(_ref) {
  var _classNames;
  var buttonLabel = _ref.buttonLabel,
    className = _ref.className,
    content = _ref.content,
    imageUrl = _ref.imageUrl,
    logoUrl = _ref.logoUrl,
    onClick = _ref.onClick,
    title = _ref.title,
    url = _ref.url,
    dataAttributes = _ref.dataAttributes,
    _ref$contentPosition = _ref.contentPosition,
    contentPosition = _ref$contentPosition === void 0 ? TEASER_CONTENT_POSITION_TYPE.right : _ref$contentPosition,
    _ref$imagePosition = _ref.imagePosition,
    imagePosition = _ref$imagePosition === void 0 ? TEASER_IMAGE_POSITION_TYPE.center : _ref$imagePosition,
    _ref$logoPosition = _ref.logoPosition,
    logoPosition = _ref$logoPosition === void 0 ? TEASER_LOGO_POSITION_TYPE.top : _ref$logoPosition,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? TEASER_STYLE_TYPE.light : _ref$styleType,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? TEASER_TYPE.size100 : _ref$type;
  var rootClassName = (0, _classnames["default"])('cds-Teaser', (_classNames = {
    'cds-Teaser--Banner': type === TEASER_TYPE.banner,
    'cds-Teaser--Size100': type === TEASER_TYPE.size100,
    'cds-Teaser--Size66': type === TEASER_TYPE.size66,
    'cds-Teaser--Size50': type === TEASER_TYPE.size50,
    'cds-Teaser--Size33': type === TEASER_TYPE.size33
  }, (0, _defineProperty2["default"])(_classNames, "cds-Teaser--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType || '')), styleType !== TEASER_STYLE_TYPE.light), (0, _defineProperty2["default"])(_classNames, 'cds-Teaser--DMK', STYLES_WITH_BACKGROUND_BANNER.includes(styleType)), (0, _defineProperty2["default"])(_classNames, "cds-Teaser--".concat((0, _upperCaseFirst.upperCaseFirst)(contentPosition || '')), contentPosition !== TEASER_CONTENT_POSITION_TYPE.right && type !== TEASER_TYPE.size33 && type !== TEASER_TYPE.size50 && type !== TEASER_TYPE.size66), _classNames), className);
  var logoClassName = (0, _classnames["default"])('cds-Teaser-Logo', {
    'cds-Teaser-Logo--Bottom': logoPosition === TEASER_LOGO_POSITION_TYPE.bottom
  });
  var imageClassName = (0, _classnames["default"])('cds-Teaser-Image', (0, _defineProperty2["default"])({}, "cds-Teaser-Image--".concat((0, _upperCaseFirst.upperCaseFirst)(imagePosition)), imagePosition !== TEASER_IMAGE_POSITION_TYPE.center));
  var buttonSize = type === TEASER_TYPE.banner ? _Button.BUTTON_SIZE["default"] : _Button.BUTTON_SIZE.small;
  var handleClick = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    e.stopPropagation();
    url && (onClick === null || onClick === void 0 ? void 0 : onClick(url));
  }, [onClick, url]);
  var isBannerBackgroundDisplayed = STYLES_WITH_BACKGROUND_BANNER.includes(styleType);
  var renderContent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isBannerBackgroundDisplayed && /*#__PURE__*/_react["default"].createElement(_BannerBackground.BannerBackground, {
      className: "cds-Teaser-DMKBackground"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: imageClassName,
      style: {
        backgroundImage: "url(".concat(imageUrl, ")")
      }
    }), logoUrl && /*#__PURE__*/_react["default"].createElement("img", {
      alt: title,
      className: logoClassName,
      src: logoUrl
    }), (title || content || buttonLabel && url) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cds-Teaser-Content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cds-Teaser-ContentInner"
    }, title && /*#__PURE__*/_react["default"].createElement("h3", {
      className: "cds-Teaser-Title"
    }, title), content && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cds-Teaser-Text"
    }, content), buttonLabel && url && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cds-Teaser-CTA"
    }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      size: buttonSize,
      onClick: handleClick
    }, buttonLabel)))));
  }, [buttonLabel, buttonSize, content, imageClassName, isBannerBackgroundDisplayed, handleClick, imageUrl, logoClassName, logoUrl, title, url]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), url && /*#__PURE__*/_react["default"].createElement("a", {
    className: "cds-Teaser-WrapperLink",
    href: url,
    onClick: handleClick
  }, renderContent), !url && renderContent);
};
exports.Teaser = Teaser;